import React from 'react';

const HalloweenDecorations = () => {
  // Generate bats
  const bats = Array.from({ length: 15 }, (_, i) => ({
    id: i,
    left: Math.random() * 100,
    top: 5 + Math.random() * 30,
    delay: Math.random() * 8,
    size: 20 + Math.random() * 20,
  }));

  // Generate spiders
  const spiders = Array.from({ length: 8 }, (_, i) => ({
    id: i,
    left: Math.random() * 100,
    delay: Math.random() * 10,
    stringLength: 50 + Math.random() * 150,
  }));

  // Generate pumpkins at bottom
  const pumpkins = Array.from({ length: 6 }, (_, i) => ({
    id: i,
    left: 5 + i * 18,
    size: 24 + Math.random() * 16,
    delay: Math.random() * 3,
  }));

  return (
    <div className="fixed inset-0 pointer-events-none z-40 overflow-hidden">
      {/* Flying bats */}
      {bats.map((bat) => (
        <div
          key={`bat-${bat.id}`}
          className="absolute animate-flutter"
          style={{
            left: `${bat.left}%`,
            top: `${bat.top}%`,
            fontSize: `${bat.size}px`,
            animationDelay: `${bat.delay}s`,
          }}
        >
          🦇
        </div>
      ))}

      {/* Dangling spiders */}
      {spiders.map((spider) => (
        <div
          key={`spider-${spider.id}`}
          className="absolute top-0"
          style={{
            left: `${spider.left}%`,
          }}
        >
          {/* Spider web string */}
          <div
            className="w-px bg-gray-400 opacity-40"
            style={{ height: `${spider.stringLength}px` }}
          />
          {/* Spider */}
          <div
            className="animate-spider-dangle text-2xl"
            style={{
              animationDelay: `${spider.delay}s`,
            }}
          >
            🕷️
          </div>
        </div>
      ))}

      {/* Glowing pumpkins at corners */}
      <div className="absolute bottom-4 left-4 text-4xl animate-pumpkin-glow">🎃</div>
      <div className="absolute bottom-4 right-4 text-4xl animate-pumpkin-glow" style={{ animationDelay: '1s' }}>🎃</div>

      {/* Spooky purple/orange gradient overlay */}
      <div className="absolute top-0 left-0 w-32 h-full bg-gradient-to-r from-purple-900/10 to-transparent" />
      <div className="absolute top-0 right-0 w-32 h-full bg-gradient-to-l from-orange-900/10 to-transparent" />
    </div>
  );
};

export default HalloweenDecorations;
